import { useTranslation } from 'next-i18next'
import operationPage from 'assets/home-operation-page.webp'
import Products from 'blocks/Products'
import type { ProductsProps } from 'blocks/Products'

export function ProductsCTA() {
  const { t } = useTranslation('home.page')

  const data: ProductsProps = {
    title: t('productsCTA.title'),
    subtitle: t('productsCTA.subtitle'),
    image: { image: operationPage, alt: '' },
    imageBlockLink: {
      url: '/cadeau',
      title: t('productsCTA.image.link'),
      locale: false,
    },
    imageBlockTitle: t('productsCTA.image.title'),
    listBlockContent: t('productsCTA.content.description'),
    listBlockTitle: t('productsCTA.content.title'),
    listBlockLink: {
      url: '/loyalty',
      title: t('productsCTA.content.link'),
      locale: false,
    },
    bannerTitle: t('productsCTA.banner.title'),
    bannerCTA: {
      title: t('productsCTA.banner.cta-title'),
      url: '/contact',
    },
  }

  return <Products {...data} />
}
